import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ComponentTask, TaskEffect, TaskSelector, TaskUpdater } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { map } from 'rxjs';
import { TaskStoreService } from './task-store.service';

@Component({
  selector: 'ubs-task-container',
  templateUrl: './task-container.component.html',
  styleUrls: ['./task-container.component.scss'],
  providers: [TaskStoreService], // Provide the store at component level
})
export class TaskContainerComponent implements OnInit, OnChanges{
  
  @Input() selectedTask:ComponentTask;
  selector:TaskSelector;
  updater:TaskUpdater;
  effect:TaskEffect;
  /**
   * Parameters passed on to the updater
   */
  updateParameters:any;

  selectedTask$ = this.componentStore.selectedTask$.pipe(map(task => task))

  constructor(
    private componentStore:UbsComponentStoreService,
    private taskStore: TaskStoreService){

  }

  ngOnInit(): void {
    this.selectedTask$.subscribe((task:ComponentTask) => {
      console.log(task)
      this.taskStore.setComponentTask(task);
      this.selectedTask = task;
      this.selector = task.selector;
      this.updater = task.updater;
      this.effect = task.effect;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["selectedTask"]){
      console.log(this.selectedTask);
    }
  }

  setUpdaterParameters(e){
    this.updateParameters = e;
  }

}
